var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "provenance-table-wrap" }, [
    _c("div", { staticClass: "provenance-table-heading" }, [
      _c("div", { staticClass: "provenance-summary" }, [
        _vm._v(
          " " +
            _vm._s(_vm.rows.length) +
            " stages, " +
            _vm._s(_vm.inputEdgeCount) +
            " inputs, " +
            _vm._s(_vm.outputEdgeCount) +
            " outputs "
        ),
      ]),
      _c("div", { staticClass: "table-controls" }, [
        _c("div", { staticClass: "provenance-hint" }, [
          _vm._v("Hover over inputs or outputs to trace their lineage."),
        ]),
        _c(
          "button",
          {
            staticClass: "collapse-all-button",
            attrs: { type: "button" },
            on: { click: _vm.toggleAllRows },
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.allRowsExpanded ? "Collapse all" : "Expand all") +
                " "
            ),
          ]
        ),
      ]),
    ]),
    _vm.rows.length
      ? _c("div", { staticClass: "provenance-table-scroll" }, [
          _c("table", { staticClass: "provenance-table" }, [
            _vm._m(0),
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.rows, function (row) {
                return _c(
                  "tr",
                  {
                    key: row.id,
                    class: {
                      "sequence-start": _vm.isSequenceStart(row),
                      expanded: _vm.isRowExpanded(row.id),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleRow(row.id)
                      },
                    },
                  },
                  [
                    _c("td", { staticClass: "sequence-cell" }, [
                      _c("span", { staticClass: "sequence-pill" }, [
                        _vm._v(_vm._s(row.sequence)),
                      ]),
                    ]),
                    _c(
                      "td",
                      { staticClass: "stage-cell" },
                      [
                        _vm.isRowExpanded(row.id)
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "type-pill stage-type",
                                  class: _vm.stageColorClass(row.activityType),
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.stageLabel(row.activityType)) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("div", [_vm._v(_vm._s(row.name))]),
                              row.repoUrl
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "stage-source-box",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "copyable-url" },
                                        [
                                          _c("input", {
                                            attrs: {
                                              "aria-label": `Source URL for ${row.name}`,
                                              readonly: "",
                                            },
                                            domProps: { value: row.repoUrl },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                              focus: function ($event) {
                                                return $event.target.select()
                                              },
                                            },
                                          }),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "copy-icon-button",
                                              attrs: {
                                                type: "button",
                                                "aria-label": `Copy source URL for ${row.name}`,
                                                title: "Copy source URL",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.copyStageSource(
                                                    row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm.copiedStageId === row.id
                                                ? _c("b-icon-check")
                                                : _c("b-icon-clipboard"),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "visit-link",
                                          attrs: {
                                            href: row.repoUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [_vm._v("Visit")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "compact-stage-cell",
                                attrs: { title: row.name },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "type-pill stage-type",
                                    class: _vm.stageColorClass(
                                      row.activityType
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.stageLabel(row.activityType)
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "compact-resource-name" },
                                  [_vm._v(_vm._s(row.name))]
                                ),
                              ]
                            ),
                      ],
                      2
                    ),
                    _c(
                      "td",
                      { class: { "resource-cell": row.inputs.length } },
                      [
                        row.inputs.length && _vm.isRowExpanded(row.id)
                          ? _c(
                              "ul",
                              { staticClass: "resource-list" },
                              _vm._l(row.inputs, function (resource) {
                                return _c(
                                  "li",
                                  {
                                    key: resource.id,
                                    class: {
                                      "resource-highlight":
                                        _vm.highlightedResourceId ===
                                        resource.id,
                                    },
                                    on: {
                                      mouseenter: function ($event) {
                                        _vm.highlightedResourceId = resource.id
                                      },
                                      mouseleave: function ($event) {
                                        _vm.highlightedResourceId = ""
                                      },
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "type-pill resource-type",
                                          class: _vm.resourceColorClass(
                                            resource.type
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(resource.type) + " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "resource-name" },
                                      [_vm._v(_vm._s(resource.name))]
                                    ),
                                    resource.location
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "resource-link-box",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "copyable-url" },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    "aria-label": `Location for ${resource.name}`,
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: resource.location,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                    focus: function ($event) {
                                                      return $event.target.select()
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "copy-icon-button",
                                                    attrs: {
                                                      type: "button",
                                                      "aria-label": `Copy location for ${resource.name}`,
                                                      title: "Copy location",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.copyResourceLocation(
                                                          resource
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.copiedResourceId ===
                                                    resource.id
                                                      ? _c("b-icon-check")
                                                      : _c("b-icon-clipboard"),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm.isHttpUrl(resource.location)
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass: "visit-link",
                                                    attrs: {
                                                      href: resource.location,
                                                      target: "_blank",
                                                      rel: "noopener noreferrer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Open ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            )
                          : row.inputs.length
                          ? _c(
                              "ul",
                              { staticClass: "compact-resource-list" },
                              _vm._l(row.inputs, function (resource) {
                                return _c(
                                  "li",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    key: resource.id,
                                    class: {
                                      "resource-highlight":
                                        _vm.highlightedResourceId ===
                                        resource.id,
                                    },
                                    attrs: { title: resource.name },
                                    on: {
                                      mouseenter: function ($event) {
                                        _vm.highlightedResourceId = resource.id
                                      },
                                      mouseleave: function ($event) {
                                        _vm.highlightedResourceId = ""
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "type-pill resource-type",
                                        class: _vm.resourceColorClass(
                                          resource.type
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(resource.type) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "compact-resource-name" },
                                      [_vm._v(_vm._s(resource.name))]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _c("span", { staticClass: "empty-value" }, [
                              _vm._v("No recorded inputs"),
                            ]),
                      ]
                    ),
                    _c(
                      "td",
                      { class: { "resource-cell": row.outputs.length } },
                      [
                        row.outputs.length && _vm.isRowExpanded(row.id)
                          ? _c(
                              "ul",
                              { staticClass: "resource-list" },
                              _vm._l(row.outputs, function (resource) {
                                return _c(
                                  "li",
                                  {
                                    key: resource.id,
                                    class: {
                                      "resource-highlight":
                                        _vm.highlightedResourceId ===
                                        resource.id,
                                    },
                                    on: {
                                      mouseenter: function ($event) {
                                        _vm.highlightedResourceId = resource.id
                                      },
                                      mouseleave: function ($event) {
                                        _vm.highlightedResourceId = ""
                                      },
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "type-pill resource-type",
                                          class: _vm.resourceColorClass(
                                            resource.type
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(resource.type) + " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "resource-name" },
                                      [_vm._v(_vm._s(resource.name))]
                                    ),
                                    resource.location
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "resource-link-box",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "copyable-url" },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    "aria-label": `Location for ${resource.name}`,
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: resource.location,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                    focus: function ($event) {
                                                      return $event.target.select()
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "copy-icon-button",
                                                    attrs: {
                                                      type: "button",
                                                      "aria-label": `Copy location for ${resource.name}`,
                                                      title: "Copy location",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.copyResourceLocation(
                                                          resource
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.copiedResourceId ===
                                                    resource.id
                                                      ? _c("b-icon-check")
                                                      : _c("b-icon-clipboard"),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm.isHttpUrl(resource.location)
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass: "visit-link",
                                                    attrs: {
                                                      href: resource.location,
                                                      target: "_blank",
                                                      rel: "noopener noreferrer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Open ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            )
                          : row.outputs.length
                          ? _c(
                              "ul",
                              { staticClass: "compact-resource-list" },
                              _vm._l(row.outputs, function (resource) {
                                return _c(
                                  "li",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    key: resource.id,
                                    class: {
                                      "resource-highlight":
                                        _vm.highlightedResourceId ===
                                        resource.id,
                                    },
                                    attrs: { title: resource.name },
                                    on: {
                                      mouseenter: function ($event) {
                                        _vm.highlightedResourceId = resource.id
                                      },
                                      mouseleave: function ($event) {
                                        _vm.highlightedResourceId = ""
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "type-pill resource-type",
                                        class: _vm.resourceColorClass(
                                          resource.type
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(resource.type) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "compact-resource-name" },
                                      [_vm._v(_vm._s(resource.name))]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _c("span", { staticClass: "empty-value" }, [
                              _vm._v("No recorded outputs"),
                            ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ])
      : _c("div", { staticClass: "empty-value" }, [
          _vm._v("No activities are available in this provenance record."),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticClass: "sequence-column" }),
      _c("col", { staticClass: "stage-column" }),
      _c("col", { staticClass: "resource-column" }),
      _c("col", { staticClass: "resource-column" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            attrs: {
              scope: "col",
              title:
                "Stages in the same group have no recorded dependency on one another.",
            },
          },
          [_vm._v("Sequence")]
        ),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Stage")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Inputs")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Outputs")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }